import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  buttonsText = {
    buttonAcceptText: 'Aceptar',
    buttonRejectText: 'Cancelar'
  }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, buttonAcceptText?: string, buttonRejectText?: string},
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) { }

  ngOnInit(): void {
    this.buttonsText.buttonAcceptText = this.data.buttonAcceptText ? this.data.buttonAcceptText : 'Aceptar';
    this.buttonsText.buttonRejectText = this.data.buttonRejectText ? this.data.buttonRejectText : 'Cancelar';
  }

  closeAction(type: boolean): void {
    this.dialogRef.close(type);
  }
}
